import { createDomain, createStore, sample } from 'effector'
import { driverModel } from '~/entities/Driver'
import { CmsBlock } from '~/shared/api'
import { MainTaxiparkCmsBlock } from '~/shared/config/enums'
import { logger } from '~/shared/lib/logger'
import { snackbarEnqueued } from '~/shared/lib/notifications'

const domain = createDomain('widgets.mainTaxipark')

export const getMainTaxiparkCmsLink = domain.createEvent()
export const getMainTaxiparkCmsLinkFx = domain.createEffect({
  async handler() {
    const response = await CmsBlock.where(
      'position',
      MainTaxiparkCmsBlock.MAIN_TAXIPARK_CMS_LINK,
    ).first()

    return response.getData()
  },
})

export const $mainTaxiparkCmsLink = createStore<CmsBlock | null>(null)
  .on(
    getMainTaxiparkCmsLinkFx.doneData,
    (_, mainTaxiparkCmsLink) => mainTaxiparkCmsLink,
  )
  .on(getMainTaxiparkCmsLinkFx.failData, () => null)

sample({
  clock: driverModel.getDriverFx,
  target: getMainTaxiparkCmsLink,
})

sample({
  clock: getMainTaxiparkCmsLink,
  target: getMainTaxiparkCmsLinkFx,
})

sample({
  clock: getMainTaxiparkCmsLinkFx.failData,
  fn(e) {
    logger.error(e)
    return {
      message: 'Ошибка получения ссылки таксопарка',
      variant: 'danger' as const,
    }
  },
  target: snackbarEnqueued,
})
